import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/follow-up-email-generator/FollowUpEmailContent.tsx");
